var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      class: [
        "color-select-option",
        {
          "color-select-option_selected": _vm.isSelected
        }
      ]
    },
    [
      _c("div", {
        class: [
          "color-select-option__inner",
          {
            "color-select-option__inner_border": _vm.hasBorder
          }
        ],
        style: _vm.background
      })
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }